import { Button, Stack } from '@mui/material';
import { ShoppingCart } from '@mui/icons-material';
import { useTranslations } from '@/i18n/use-translations.tsx';
import PaymentProcessingModal from './payment-processing.modal';

interface AddToCartButtonProps {
  countItems?: number;
  isLoading?: boolean;
  onClick: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  testId?: string;
  disabled?: boolean;
  eventId?: string;
}

export default function AddToCartButton({
  countItems,
  isLoading = false,
  onClick,
  testId,
  disabled = false,
  eventId,
}: AddToCartButtonProps) {
  const t = useTranslations();

  const hasItems = countItems && countItems > 0;

  return (
    <>
      <Button variant="outlined" onClick={onClick} data-testid={testId} loading={isLoading} disabled={disabled}>
        {hasItems ? (
          <Stack direction="row" alignItems="center" gap={1}>
            {countItems}
            <ShoppingCart />
          </Stack>
        ) : (
          t('common.add')
        )}
      </Button>
      <PaymentProcessingModal eventId={eventId} />
    </>
  );
}
